/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Use_Case_Content_CreationInputs */



/**
* | output |
* | --- |
* | "Content" |
*
* @param {Model_Showcase_Use_Case_Content_CreationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_use_case_content_creation = /** @type {((inputs?: Model_Showcase_Use_Case_Content_CreationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Use_Case_Content_CreationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Content")
	return /** @type {LocalizedString} */ ("Content")
});